module.exports = __webpack_public_path__ + "static/media/poweredbytnns-tb.21546940.png";